const pow: Record<number, number> = {};
export const roundNumber = (num: number, digits: number): number => {
  if (!pow[digits]) {
    pow[digits] = Math.pow(10, digits);
  }
  return Math.round((num + Number.EPSILON) * pow[digits]!) / pow[digits]!;
};

export const isInteger = (num: number): boolean => num % 1 === 0;
